export const SET_ERROR = "@my-ac/leave/SET_ERROR";
export const SET_LEAVE_COUNTS = "@my-ac/leave/SET_LEAVE_COUNTS";
export const SET_LEAVE_LIST = "@my-ac/leave/SET_LEAVE_LIST";
export const SET_APPLY_LEAVE_LOADING = "@my-ac/leave/SET_APPLY_LEAVE_LOADING";




